import CampusHeader from '../../components/feature/CampusHeader';
import Footer from '../../components/feature/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <CampusHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <p className="text-gray-700 mb-8">
          We respect your privacy. This policy explains what data we collect, how we use it, and your rights.
        </p>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Information We Collect</h2>
          <p className="text-gray-700">
            Account information, listings and transaction details, messages with buyers/sellers, device and usage data.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">How We Use Information</h2>
          <p className="text-gray-700">
            To operate the marketplace, facilitate messaging, prevent fraud, personalize content, and improve features including Campus Guru.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Data Sharing</h2>
          <p className="text-gray-700">
            We only share data with service providers and as required by law. We do not sell personal information.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Your Rights</h2>
          <p className="text-gray-700">
            You can access, correct, or delete your data, and opt-out of certain processing where applicable.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900">Contact</h2>
          <p className="text-gray-700">
            For privacy questions, contact <a href="mailto:hello@synccore.com" className="text-blue-600 hover:underline">hello@synccore.com</a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;